import {concat} from "../core/collections";
import {prepareChildren, randomId} from "./util";
import {deepClone, deepMerge} from "../core/collections";
import NODETYPE from "./nodetype"
import {updateView} from "./patch";
import {debounce} from "../core";
// import {th} from "./hscript-esm";

/**
 * @property {Function} [onCreate]
 * @property {Function} [onUpdate]
 * @property {Function} [onMount]
 */
export class View {
    static $type = NODETYPE.VIEW

    constructor(opt = {}, construct = opt) {
        this.$name = this.constructor.name
        this.isView = true
        this.$constructor = construct
        let cons = Object.getOwnPropertyNames(this.$constructor)
        for (let i = 0; i < cons.length; i++) {
            const prop = cons[i]
            if (this.$constructor[prop] instanceof Function) {
                this[prop] = this.$constructor[prop]
            } else {
                this[prop] = deepClone(this.$constructor[prop])
            }
        }
    }

    render() {
        return ""
    }

    static create(name, opt) {
        let c = new View(opt)
        if (!opt.render) console.warn("render method is not defined")
        c.$name = name
        return c
    }

    createInstance(props, children) {
        const construct = this.$constructor
        const name = this.$name
        let inst = new View(construct, construct)
        inst.$name = name
        inst.$instanceId = randomId()
        return inst.updateInstance(props, children)
    }

    updateInstance(props, children) {
        if (!this.props) this.props = {}
        if (props)
            concat(this.props, props, true)
        if (children)
            children = prepareChildren(children)
        this.children = children
        this.$instanceId = randomId()
        return this
    }

    $update = debounce(()=> {
        this.isDirty = true
        updateView(this)
        // console.log(this)
    }, 50)

    isDirty = true

    shouldUpdate = () => this.isDirty

    remove() {
        if (!this.isFrag) {
            this.$node.target.remove()
        }
        for (const ch of this.$node.nodes) {
            ch.remove();
        }
    }

    firstElement() {
        if (this.$node)
            return this.$node.firstElement()
    }

    lastElement() {
        if (this.$node)
            return this.$node.lastElement()
    }
}
// global.View = View